export default __webpack_public_path__ + "static/exp3-f9fb6e669349e5ffb3d990fc49b4949d.webp";